"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PencilSquare24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V11H23V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H14V3H4Z", fill: "#383F49" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9927 1.27764C19.3685 0.90574 19.9779 0.908908 20.3474 1.27843L22.722 3.65291C23.0943 4.02524 23.0907 4.63575 22.7228 5.00763L13 15H9V11.5L18.9927 1.27764ZM11 12V13H12L18.8416 6.19014L17.8101 5.15862L11 12ZM19.1556 3.80701L20.1933 4.84476L20.7063 4.33419L19.6661 3.2941L19.1556 3.80701Z", fill: "#383F49" }));
}
function PencilSquare24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PencilSquare24Svg, Object.assign({}, svgProps)));
}
exports.default = PencilSquare24;
//# sourceMappingURL=PencilSquare24.js.map